/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Companyhistory1Inputs */

const ja_company_companyhistory1 = /** @type {(inputs: Company_Companyhistory1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company History`)
};

const en_company_companyhistory1 = /** @type {(inputs: Company_Companyhistory1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company History`)
};

/**
* | output |
* | --- |
* | "Company History" |
*
* @param {Company_Companyhistory1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_companyhistory1 = /** @type {((inputs?: Company_Companyhistory1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Companyhistory1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_companyhistory1(inputs)
	return en_company_companyhistory1(inputs)
});
export { company_companyhistory1 as "company_companyHistory" }